import IztExhibitCard from './src/izt-exhibit-card.vue'

IztExhibitCard.install = Vue => {
  Vue.component(IztExhibitCard.name, IztExhibitCard)
}

export default IztExhibitCard